export enum StatusType {
  ED = "ed",
  IFT = "ift",
}
